module.exports = __webpack_public_path__ + "img/MCLAREN.89f49b8.jpg";